/* eslint-disable react/require-default-props */
import React from 'react'
import IModal from '../../interfaces/modal'
import Icon from '../icon'

import {
  Overlay,
  Container,
  Header,
  CloseButton,
} from './styles'
import { If } from '../if/if'

type IProps = IModal & {
  isVisible: boolean;
  toggleVisibility: (value?: boolean) => void;
  hasHeader?: boolean;
  styles?: any;
}

const Modal = ({
  isVisible,
  toggleVisibility,
  hasHeader = true,
  content: { title, component: Component, width },
  styles = {},
}: IProps) => (
  <Overlay isVisible={isVisible}>
    <Container style={{ width, ...styles }}>
      <If condition={!hasHeader}>
        <Header>
          <h1>{title}</h1>
          <button type="button" aria-label="Close" onClick={() => toggleVisibility(false)}>
            <Icon name="close" />
          </button>
        </Header>
      </If>
      <If condition={hasHeader}>
        <CloseButton type="button" onClick={() => toggleVisibility(false)}>
          <Icon name="close" size={25} />
        </CloseButton>
      </If>
      <main>{ Component && <Component /> }</main>
    </Container>
  </Overlay>
)

export default Modal
